import React from 'react';
import { useTranslation } from 'react-i18next';

const FILE_RE = /\.(mp4|webm)(\?|$)/i;

export const ASPECTS = ['16:9', '9:16', '1:1', '4:5'];
const ratioOf = (aspect) => {
  const [w, h] = (ASPECTS.includes(aspect) ? aspect : '16:9').split(':').map(Number);
  return w / h;
};

/**
 * Плеер для видео любой ориентации.
 * — Загруженный файл (mp4/webm) показывается в собственных пропорциях: вертикальный ролик
 *   не растягивается на всю ширину, а стоит по центру, высота ограничена высотой экрана.
 * — Встроенный ролик (YouTube, VK, RuTube, Vimeo) получает рамку нужных пропорций (`aspect`).
 * Вокруг ролика — тёмная «сцена» с мягким свечением, поэтому поля по бокам выглядят оформленными.
 */
const VideoPlayer = ({ url, aspect = '16:9', poster, title, className = '' }) => {
  const { t } = useTranslation();
  if (!url) return null;
  const isFile = FILE_RE.test(url) || url.startsWith('/api/media/');
  const ratio = ratioOf(aspect);

  return (
    <div className={`relative overflow-hidden border-2 border-black bg-[#0d0b08] ${className}`}
      style={{ backgroundImage: 'radial-gradient(ellipse at center, rgba(196,30,58,0.18), rgba(0,0,0,0) 70%)' }}>
      <div className="flex justify-center">
        {isFile ? (
          <video src={url} poster={poster || undefined} controls playsInline preload="metadata"
            aria-label={title || t('pl.courses.videoTitle')}
            className="block bg-black w-auto h-auto max-w-full"
            style={{ maxHeight: 'min(80vh, 720px)' }} />
        ) : (
          <div className="relative w-full bg-black"
            style={{
              aspectRatio: String(ratio),
              // вертикальный ролик не должен быть выше экрана: ширина считается от допустимой высоты
              maxWidth: ratio < 1 ? `min(100%, calc(min(80vh, 720px) * ${ratio}))` : '100%',
            }}>
            <iframe src={url} title={title || t('pl.courses.videoTitle')} loading="lazy"
              className="absolute inset-0 w-full h-full border-0" allowFullScreen
              allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
              referrerPolicy="strict-origin-when-cross-origin" />
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
